
import Cookies from 'js-cookie';
import { cookieNames, trackingDimensionConstants, trackingOrderTypes } from 'shared/settings/constants';

export function getVisitorID() {
    let cookies = document.cookie.split(';')
    let visitorId = '';
    let regex = /^\s?VisitorID=(.*)/;
    cookies.forEach((cookie) => {
        let match = regex.exec(cookie);
        if (match) {
            visitorId = match[1];
        }
    })
    return visitorId;
}

export function track(payload, callback, event) {
    window.dataLayer = window.dataLayer || [];
    if (window.google_tag_manager && callback) {
        if (event) {
            event.preventDefault();
        }
        payload.eventCallback = callback;
    }
    window.dataLayer.push(payload);
    console.debug(JSON.stringify(payload));
}

export function trackInteractionEvent(eventCategory, eventAction, eventLabel) {
    let payload = {
        event: 'interactionEvent',
        eventcategory: eventCategory,
        eventaction: eventAction,
        eventlabel: eventLabel,
        eventnoninteraction: false,
    }
    track(payload);
}

export function getOneBlockTrackingStrings(ob) {
    const headlineElm = ob.querySelector('.c-ob__headline');
    const headline = headlineElm ? headlineElm.innerText : '';
    const sectionElm = ob.closest('.c-section');
    const sectionHeadlineElm = sectionElm ? sectionElm.querySelector('.c-section__headline') : null;
    const sectionHeadline = sectionHeadlineElm ? sectionHeadlineElm.innerText : '';
    let headlines = [];
    if (sectionHeadline) {
        headlines.push(sectionHeadline);
    }
    if (headline) {
        headlines.push(headline);
    }
    const culture = getCulture();

    return {
        action: `${headlines.join(' | ')} ${culture} ${location.pathname}`,
        headline,
        allHeadlines: headlines.join(' | '),
        culture,
        pathname: location.pathname,
        pageType: getPageType(),
        visitorID: getVisitorID(),
        label: getVisitorID(),
    }
}

export function getCulture() {
    return document.documentElement.getAttribute('lang');
}

export function getPageType() {
    const pageTypeEntry = window.dataLayer.find((entry) => entry.hasOwnProperty('PageType'));
    return pageTypeEntry ? pageTypeEntry.PageType : '';
}

export function oneBlockBuildLineItemTrackingParameters() {
    return {
        dimension9: trackingDimensionConstants.NO_DATA,
        dimension10: trackingOrderTypes.NEW_ORDER,
        dimension11: trackingDimensionConstants.NO_DATA,
    };
}
